<ul class="error-invalid" *ngIf="hasErrors()">
  <li *ngFor="let error of getErrors()">{{ error | translate }}</li>
</ul>
